import config from "config/config";
import getTokens from "api/getTokens";
import { handleOrderBy } from "./common";

const { baseUrl, clientUrl } = config;

export default function getCsv(dateFrom = "", dateTo = "", reason = "", orderBy = "") {
  const order = handleOrderBy(orderBy);
  const endpoint = `${baseUrl}/v1/stealers/csv/?dateFrom=${dateFrom}&dateTo=${dateTo}&reason=${reason}&sortBy=${order}`;
  let access = "";
  const tokens = getTokens();
  if (tokens && tokens.access && tokens.access.token) {
    access = tokens.access.token;
  } else {
    window.location.href = "/login";
  }
  const options = {
    method: "GET",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": `${clientUrl || ""}`,
      "Access-Control-Allow-Credentials": true,
      Authorization: `bearer ${access}`,
    },
  };
  // console.log('login endpoint', {endpoint, BODY });
  return fetch(endpoint, options)
    .then((response) => {
      if (response.status !== 200 && response.status !== 201 && response.status !== 204) {
        throw new Error();
      }
      return response;
    })
    .catch((e) => {
      // eslint-disable-next-line
      console.log("error", e);
    });
}
